import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOtherGlyphSecondary from './svgs/OtherGlyphSecondary.js';
import SvgOtherGlyph from './svgs/OtherGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var otherGlyph = (props => useIcon(SvgOtherGlyph, SvgOtherGlyphSecondary, props));

export { otherGlyph as default };
